import { useState } from "react";
import { ChevronDown, ChevronUp, Monitor } from "lucide-react";

export default function ComingSoon() {
  const [showMore, setShowMore] = useState(false);

  return (
    <div
      className="min-h-screen flex flex-col px-6 pt-8 pb-12"
      style={{ backgroundColor: "#061136" }}
    >
      <div className="w-full max-w-md mx-auto flex flex-col items-center text-center">
        <div className="w-40 h-28 mb-6 flex items-center justify-center">
          <img
            src="https://fluxi.co/wp-content/uploads/2025/07/Logo-fluxi-zorro-mascota.webp"
            alt="Fluxi Logo"
            className="w-full h-full object-contain object-center"
            style={{ objectPosition: "center" }}
          />
        </div>

        <Monitor className="w-16 h-16 text-white/80 mb-5" strokeWidth={1.5} />

        <h1 className="text-white text-4xl font-bold mb-6 leading-tight">
          Debes utilizar un computador para acceder a la aplicación
        </h1>

        <button
          onClick={() => setShowMore(!showMore)}
          className="flex items-center gap-2 text-white/70 hover:text-white transition-colors duration-200 text-sm font-medium mb-6"
        >
          <span>Más información</span>
          {showMore ? (
            <ChevronUp className="w-4 h-4" />
          ) : (
            <ChevronDown className="w-4 h-4" />
          )}
        </button>

        <div
          className={`overflow-hidden transition-all duration-300 ease-in-out w-full ${
            showMore ? "max-h-[600px] opacity-100" : "max-h-0 opacity-0"
          }`}
        >
          <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-6 border border-white/10">
            <h2 className="text-white text-lg font-semibold mb-4">
              ¿Por qué usar Fluxi desde una computadora?
            </h2>
            <p className="text-white/80 text-sm leading-relaxed">
              Crear tiendas y páginas profesionales requiere espacio. En Fluxi
              tienes acceso a herramientas potentes: personalizador visual,
              gestor de órdenes, creador de guiones, integraciones con
              plataformas de envío y mucho más.
            </p>
            <p className="text-white/80 text-sm leading-relaxed mt-4">
              Todas estas herramientas funcionan mejor en pantalla grande, donde
              puedes ver cada detalle y trabajar con comodidad. Por eso Fluxi
              está diseñado para computadora, no para móvil.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
